import { Component, OnInit } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-fornecedor-modal',
  templateUrl: './fornecedor-modal.component.html',
  styleUrls: ['./fornecedor-modal.component.scss']
})
export class FornecedorModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<FornecedorModalComponent>,
  ) { }

  ngOnInit(): void {
  }

  fechar() {
    this.dialogRef.close();
  }

}
